import OnboardingReviewNumbers from '../../../onboarding/components/OnboardingReviewNumbers';

export default function OnboardingReviewNumbersScreen() {
    return <OnboardingReviewNumbers />;
}
